(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[486],{

/***/ 27491:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embedded-checkout/cart-button",
      function () {
        return __webpack_require__(97429);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LS": function() { return /* binding */ setItem; },
/* harmony export */   "MU": function() { return /* binding */ setListener; },
/* harmony export */   "cl": function() { return /* binding */ removeItem; },
/* harmony export */   "rV": function() { return /* binding */ getItem; }
/* harmony export */ });
function safeGetLocalStorage() {
    try {
        return window === null || window === void 0 ? void 0 : window.localStorage;
    } catch (_err) {
        // Catch a SecurityError that is thrown if the browser has disabled access
        // to local storage
        return undefined;
    }
}
function setListener(cb) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return;
    }
    window.addEventListener("storage", function(e) {
        cb(e);
    });
}
// biome-ignore lint/suspicious/noExplicitAny: Allow saving anything in local storage
function setItem(key, value) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return;
    }
    var stringToStore = JSON.stringify(value);
    storage.setItem(key, stringToStore);
}
function getItem(key) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return undefined;
    }
    var string = storage.getItem(key);
    return string ? JSON.parse(string) : string;
}
function removeItem(key) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return;
    }
    storage.removeItem(key);
}


/***/ }),

/***/ 4638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rV": function() { return /* binding */ getItem; },
  "cl": function() { return /* binding */ removeItem; },
  "LS": function() { return /* binding */ setItem; }
});

// UNUSED EXPORTS: isAvailable

// EXTERNAL MODULE: ../../../../browser-sdk/src/libraries/local-storage.ts
var local_storage = __webpack_require__(47878);
;// CONCATENATED MODULE: ../../../../browser-sdk/src/libraries/broadcast-message.js

function broadcastMessageToTabs(key, value) {
    (0,local_storage/* setItem */.LS)(key, value);
    (0,local_storage/* removeItem */.cl)(key);
}

;// CONCATENATED MODULE: ../../../../browser-sdk/src/libraries/session-storage.ts

function safeGetSessionStorage() {
    try {
        return window === null || window === void 0 ? void 0 : window.sessionStorage;
    } catch (_err) {
        // Catch a SecurityError that is thrown if the browser has disabled access
        // to session storage
        return undefined;
    }
}
function isAvailable() {
    return !!safeGetSessionStorage();
}
function getItem(key) {
    var storage = safeGetSessionStorage();
    if (!storage) {
        return undefined;
    }
    var string = storage.getItem(key);
    return string && JSON.parse(string);
}
function setItem(key, value) {
    var ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _broadcast = ref.broadcast, broadcast = _broadcast === void 0 ? false : _broadcast;
    var storage = safeGetSessionStorage();
    if (!storage) {
        return;
    }
    var stringToStore = JSON.stringify(value);
    storage.setItem(key, stringToStore);
    if (broadcast) {
        broadcastMessageToTabs("BROADCAST", {
            key: key,
            data: value
        });
    }
}
function removeItem(key) {
    var storage = safeGetSessionStorage();
    if (!storage) {
        return;
    }
    storage.removeItem(key);
}


/***/ }),

/***/ 78960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K$": function() { return /* binding */ deleteJSON; },
/* harmony export */   "ZV": function() { return /* binding */ fetchJSON; },
/* harmony export */   "ty": function() { return /* binding */ postJSON; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11204);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40891);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80460);



function fetchJSON(path) {
    return _fetchJSON.apply(this, arguments);
}
function _fetchJSON() {
    _fetchJSON = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(path) {
        var ref, _throwOnError, throwOnError, response;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, _throwOnError = ref.throwOnError, throwOnError = _throwOnError === void 0 ? true : _throwOnError;
                    return [
                        4,
                        globalThis.fetch(path, {
                            headers: new Headers({
                                Accept: "application/json"
                            }),
                            credentials: "same-origin"
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        unwrapJSONResponse(response, throwOnError)
                    ];
            }
        });
    });
    return _fetchJSON.apply(this, arguments);
}
function postJSON(path, body) {
    return _postJSON.apply(this, arguments);
}
function _postJSON() {
    _postJSON = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(path, body) {
        var ref, _throwOnError, throwOnError, _headers, headers, _credentials, credentials, response;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {}, _throwOnError = ref.throwOnError, throwOnError = _throwOnError === void 0 ? true : _throwOnError, _headers = ref.headers, headers = _headers === void 0 ? {} : _headers, _credentials = ref.credentials, credentials = _credentials === void 0 ? "same-origin" : _credentials;
                    return [
                        4,
                        globalThis.fetch(path, {
                            method: "POST",
                            body: JSON.stringify(body),
                            headers: new Headers((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                                Accept: "application/json",
                                "Content-Type": "application/json"
                            }, headers)),
                            credentials: credentials
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        unwrapJSONResponse(response, throwOnError)
                    ];
            }
        });
    });
    return _postJSON.apply(this, arguments);
}
function deleteJSON(path) {
    return _deleteJSON.apply(this, arguments);
}
function _deleteJSON() {
    _deleteJSON = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(path) {
        var ref, _throwOnError, throwOnError, response;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, _throwOnError = ref.throwOnError, throwOnError = _throwOnError === void 0 ? true : _throwOnError;
                    return [
                        4,
                        globalThis.fetch(path, {
                            method: "DELETE",
                            headers: new Headers({
                                Accept: "application/json",
                                "Content-Type": "application/json"
                            }),
                            credentials: "same-origin"
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        unwrapJSONResponse(response, throwOnError)
                    ];
            }
        });
    });
    return _deleteJSON.apply(this, arguments);
}
function unwrapJSONResponse(response, throwOnError) {
    return _unwrapJSONResponse.apply(this, arguments);
}
function _unwrapJSONResponse() {
    _unwrapJSONResponse = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(response, throwOnError) {
        var errorMessage, originalMessage, errData, ref, ref1, ref2, ref3, res, message, data, err, _$err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (response.ok || !throwOnError) {
                        return [
                            2,
                            response.json()
                        ];
                    }
                    errorMessage = "HTTP Status Error: ".concat(response.status);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    res = _state.sent();
                    message = ((ref = res.error) === null || ref === void 0 ? void 0 : ref.message) || ((ref1 = res.meta) === null || ref1 === void 0 ? void 0 : ref1.error);
                    if (message) {
                        errorMessage = "HTTP Status Error: ".concat(response.status, " - ").concat(message);
                        originalMessage = message;
                    }
                    data = ((ref2 = res.error) === null || ref2 === void 0 ? void 0 : ref2.data) || ((ref3 = res.meta) === null || ref3 === void 0 ? void 0 : ref3.errorData);
                    if (data) {
                        errData = data;
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    err = _state.sent();
                    // biome-ignore lint/suspicious/noConsole: log
                    console.error(err);
                    return [
                        3,
                        4
                    ];
                case 4:
                    _$err = new Error(errorMessage);
                    // Mark this error as having the response data to work with
                    // As opposed to a network error
                    _$err.responseSucceeded = true;
                    _$err.statusCode = response.status;
                    _$err.originalMessage = originalMessage;
                    _$err.data = errData;
                    throw _$err;
            }
        });
    });
    return _unwrapJSONResponse.apply(this, arguments);
}


/***/ }),

/***/ 82052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ru": function() { return /* binding */ appendQuery; },
  "J2": function() { return /* binding */ appendResourceType; },
  "Ri": function() { return /* binding */ createURL; },
  "$1": function() { return /* binding */ isDomainValid; }
});

// UNUSED EXPORTS: buildPath

// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(9334);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/ramda@0.30.1/node_modules/ramda/es/isNil.js
var isNil = __webpack_require__(49868);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/next@12.3.7_@babel+core@7.27.3_babel-plugin-macros@3.1.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/compiled/native-url/index.js
var native_url = __webpack_require__(74617);
;// CONCATENATED MODULE: ../../../../libraries/src/language-helpers/objects/check-object-keys.ts
/* eslint array-callback-return: "off" */ 
function checkParam(obj) {
    Object.entries(obj).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        if (typeof value === "object" && value !== null) {
            checkParam(value);
        }
        if (value === undefined || value === null) {
            throw new Error("".concat(key, " is a mandatory parameter"));
        }
    });
}

;// CONCATENATED MODULE: ../../../../libraries/src/url/index.ts
/** biome-ignore-all lint/style/useNodejsImportProtocol: webpack */ 



function createURL(param) {
    var host = param.host, path = param.path, queryParams = param.queryParams, hash = param.hash;
    var url = new URL("".concat(host).concat(path));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(queryParams)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], value = _value[1];
            if (value === undefined || value === null) {
                continue;
            }
            if (typeof value === "object") {
                url.searchParams.set(key, JSON.stringify(value));
            } else {
                url.searchParams.set(key, value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (hash) {
        url.hash = hash;
    }
    return url.toString();
}
function appendQuery(path, query) {
    if ((0,isNil/* default */.Z)(query)) {
        return path;
    }
    var url = new URL(path, "https://example.com");
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(query)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,_sliced_to_array/* default */.Z)(_step.value, 2), name = _value[0], value = _value[1];
            if (!(0,isNil/* default */.Z)(value)) {
                url.searchParams.append(name, value);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return url.pathname + url.search;
}
function appendResourceType(type, url) {
    checkParam({
        type: type
    });
    checkParam({
        url: url
    });
    var parsed = (0,native_url.parse)(url);
    var path = buildPath(type, parsed);
    if (!parsed.hostname) {
        return path;
    }
    return "".concat(parsed.protocol, "//").concat(parsed.host).concat(path);
}
function buildPath(type, param) {
    var pathname = param.pathname, search = param.search;
    if (search) {
        return "".concat(pathname, ".").concat(type).concat(search);
    }
    return "".concat(pathname, ".").concat(type);
}
var DOMAIN_REGEX = /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/;
function isDomainValid(domain) {
    return !!(domain === null || domain === void 0 ? void 0 : domain.match(DOMAIN_REGEX));
}


/***/ }),

/***/ 92146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40891);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61866);
/* harmony import */ var _purple_dot_browser_sdk_src_libraries_local_storage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47878);



function isInternalUser() {
    var internalUser = (0,_purple_dot_browser_sdk_src_libraries_local_storage__WEBPACK_IMPORTED_MODULE_0__/* .getItem */ .rV)("internal-user");
    if (!internalUser) {
        return false;
    }
    return internalUser.isInternalUser === true;
}
function isKnownBot() {
    var BOTS = /(pingdom)|(google)/i;
    return __webpack_require__.g.navigator.userAgent.match(BOTS);
}
var FilterWrapper = {
    track: function track(event, properties) {
        if (!(isInternalUser() || isKnownBot())) {
            var ref;
            (ref = window.FS) === null || ref === void 0 ? void 0 : ref.call(window, "trackEvent", {
                name: event,
                properties: properties
            });
        } else {
            // biome-ignore lint/suspicious/noConsole: debug
            console.log("INTERNAL USER - Track: ", event, properties);
        }
    }
};
var Analytics = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, FilterWrapper), {
    trackProductViewed: function trackProductViewed(param) {
        var itemId = param.itemId, slug = param.slug;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackProductViewed()");
        }
        if (!slug) {
            throw new Error("No slug provided to Analytics.trackProductViewed()");
        }
        FilterWrapper.track("Product Viewed", {
            itemId: itemId,
            slug: slug,
            product_id: slug
        });
    },
    trackOrderCreated: function trackOrderCreated(param) {
        var orderReference = param.orderReference;
        if (!orderReference) {
            throw new Error("No orderReference provided to Analytics.trackOrderCreated()");
        }
        FilterWrapper.track("Order Created", {
            orderReference: orderReference
        });
    },
    trackLastSeenProductClicked: function trackLastSeenProductClicked() {
        FilterWrapper.track("Last Seen Product Clicked");
    },
    trackInputChanged: function trackInputChanged(param) {
        var name = param.name;
        if (!name) {
            throw new Error("No name provided to Analytics.trackInputChanged");
        }
        FilterWrapper.track("".concat(name, " Changed"));
    },
    trackUserProgressed: function trackUserProgressed(pageName) {
        if (!pageName) {
            throw new Error("No page provided to Analytics.trackUserProgressed");
        }
        FilterWrapper.track("User Progressed", {
            pageName: pageName
        });
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (Analytics);


/***/ }),

/***/ 17665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _EmbeddedPage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33753);

/* harmony default export */ __webpack_exports__["Z"] = (_EmbeddedPage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 34153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ FullStorySnippetString; },
/* harmony export */   "S": function() { return /* binding */ FullStorySnippet; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52473);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29342);
/* harmony import */ var react_inline_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84018);
/* harmony import */ var react_inline_script__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_inline_script__WEBPACK_IMPORTED_MODULE_2__);



var FullStorySnippetString = '\n  window[\'_fs_host\'] = \'fullstory.com\';\n  window[\'_fs_script\'] = \'edge.fullstory.com/s/fs.js\';\n  window[\'_fs_org\'] = \'RNRSF\';\n  window[\'_fs_namespace\'] = \'FS\';\n  !function(m,n,e,t,l,o,g,y){var s,f,a=function(h){\n  return!(h in m)||(m.console&&m.console.log&&m.console.log(\'FullStory namespace conflict. Please set window["_fs_namespace"].\'),!1)}(e)\n  ;function p(b){var h,d=[];function j(){h&&(d.forEach((function(b){var d;try{d=b[h[0]]&&b[h[0]](h[1])}catch(h){return void(b[3]&&b[3](h))}\n  d&&d.then?d.then(b[2],b[3]):b[2]&&b[2](d)})),d.length=0)}function r(b){return function(d){h||(h=[b,d],j())}}return b(r(0),r(1)),{\n  then:function(b,h){return p((function(r,i){d.push([b,h,r,i]),j()}))}}}a&&(g=m[e]=function(){var b=function(b,d,j,r){function i(i,c){\n  h(b,d,j,i,c,r)}r=r||2;var c,u=/Async$/;return u.test(b)?(b=b.replace(u,""),"function"==typeof Promise?new Promise(i):p(i)):h(b,d,j,c,c,r)}\n  ;function h(h,d,j,r,i,c){return b._api?b._api(h,d,j,r,i,c):(b.q&&b.q.push([h,d,j,r,i,c]),null)}return b.q=[],b}(),y=function(b){function h(h){\n  "function"==typeof h[4]&&h[4](new Error(b))}var d=g.q;if(d){for(var j=0;j<d.length;j++)h(d[j]);d.length=0,d.push=h}},function(){\n  (o=n.createElement(t)).async=!0,o.crossOrigin="anonymous",o.src="https://"+l,o.onerror=function(){y("Error loading "+l)}\n  ;var b=n.getElementsByTagName(t)[0];b&&b.parentNode?b.parentNode.insertBefore(o,b):n.head.appendChild(o)}(),function(){function b(){}\n  function h(b,h,d){g(b,h,d,1)}function d(b,d,j){h("setProperties",{type:b,properties:d},j)}function j(b,h){d("user",b,h)}function r(b,h,d){j({\n  uid:b},d),h&&j(h,d)}g.identify=r,g.setUserVars=j,g.identifyAccount=b,g.clearUserCookie=b,g.setVars=d,g.event=function(b,d,j){h("trackEvent",{\n  name:b,properties:d},j)},g.anonymize=function(){r(!1)},g.shutdown=function(){h("shutdown")},g.restart=function(){h("restart")},\n  g.log=function(b,d){h("log",{level:b,msg:d})},g.consent=function(b){h("setIdentity",{consent:!arguments.length||b})}}(),s="fetch",\n  f="XMLHttpRequest",g._w={},g._w[f]=m[f],g._w[s]=m[s],m[s]&&(m[s]=function(){return g._w[s].apply(this,arguments)}),g._v="2.0.0")\n  }(window,document,window._fs_namespace,"script",window._fs_script);\n';
function FullStorySnippet() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_inline_script__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: FullStorySnippetString
    });
}


/***/ }),

/***/ 7307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ routeTo; },
/* harmony export */   "r": function() { return /* binding */ Link; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11204);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40891);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61866);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9469);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58207);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52473);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53953);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45511);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29342);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1578);






function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: inherit;\n\n  :hover {\n    color: inherit;\n  }\n\n  text-decoration: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var Link = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(function(_param) {
    var href = _param.href, path = _param.path, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "href",
        "path",
        "children"
    ]);
    if (typeof href === "string" && !href.startsWith("/")) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            href: href
        }, props), {
            children: children
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        as: path,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, props), {
            children: children
        }))
    });
}).withConfig({
    componentId: "sc-f95a3008-0"
})(_templateObject(), function(param) {
    var underline = param.underline;
    return underline ? "underline" : "none";
});
function routeTo(href, path) {
    return _routeTo.apply(this, arguments);
}
function _routeTo() {
    _routeTo = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(href, path) {
        var scroll;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    scroll = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : true;
                    return [
                        4,
                        next_router__WEBPACK_IMPORTED_MODULE_3___default().push(href, path)
                    ];
                case 1:
                    _state.sent();
                    if (scroll) {
                        scrollToTop();
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _routeTo.apply(this, arguments);
}
function scrollToTop() {
    if (__webpack_require__.g.window) {
        __webpack_require__.g.window.scrollTo(0, 0);
    }
}


/***/ }),

/***/ 97429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ cart_button; }
});

// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(40891);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(61866);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(58207);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52473);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/@juggle+resize-observer@3.4.0/node_modules/@juggle/resize-observer/lib/exports/resize-observer.js + 23 modules
var resize_observer = __webpack_require__(29515);
// EXTERNAL MODULE: ../../../../browser-sdk/src/libraries/local-storage.ts
var local_storage = __webpack_require__(47878);
// EXTERNAL MODULE: ../../../../browser-sdk/src/libraries/session-storage.ts + 1 modules
var session_storage = __webpack_require__(4638);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/@use-it+event-listener@0.1.7_react@18.3.1/node_modules/@use-it/event-listener/dist/event-listener.m.js
var event_listener_m = __webpack_require__(99649);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(29342);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/react-async@10.0.1_react@18.3.1/node_modules/react-async/dist-web/index.js
var dist_web = __webpack_require__(90902);
// EXTERNAL MODULE: ../../../../../node_modules/.pnpm/styled-components@5.3.11_@babel+core@7.27.3_react-dom@18.3.1_react@18.3.1__react-is@18.3.1_react@18.3.1/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(1578);
;// CONCATENATED MODULE: ./components/EmbeddedApp/CartButton/AlertIcon.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n  height: ",
        ";\n  width: ",
        ";\n  background: #8f17d1;\n  border-radius: 50%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var AlertIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a21f9be9-0"
})(_templateObject(), function(param) {
    var styling = param.styling;
    return styling.padding;
}, function(param) {
    var styling = param.styling;
    return styling.padding;
}, function(param) {
    var styling = param.styling;
    return "calc((".concat(styling.height, " - ").concat(styling.padding, " * 2) * 0.375)");
}, function(param) {
    var styling = param.styling;
    return "calc((".concat(styling.width, " - ").concat(styling.padding, " * 2) * 0.375)");
});

;// CONCATENATED MODULE: ./components/EmbeddedApp/CartButton/Button.tsx


function Button_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  position: relative;\n  background: 0;\n  border: 0;\n  width: 100%;\n  margin: 0;\n  line-height: 0px;\n  cursor: pointer;\n  padding: ",
        ";\n\n  & > svg > circle,\n  & > svg > line {\n    stroke: ",
        ";\n    stroke-width: ",
        ";\n  }\n"
    ]);
    Button_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



function Button(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, (0,_object_spread/* default */.Z)({
        type: "button",
        id: "cart-button"
    }, props));
}
var StyledButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-17b6f8ee-0"
})(Button_templateObject(), function(param) {
    var styling = param.styling;
    return styling.padding;
}, function(param) {
    var styling = param.styling;
    return styling.fill;
}, function(param) {
    var styling = param.styling;
    return styling.strokeWidth;
});

;// CONCATENATED MODULE: ./components/EmbeddedApp/CartButton/ClockIcon.tsx


function ClockIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "white",
                strokeWidth: "2",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "11.75",
                y1: "13",
                x2: "11.75",
                y2: "7",
                stroke: "white",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "11.5",
                y1: "12.5",
                x2: "16.5",
                y2: "16.5",
                stroke: "white",
                strokeWidth: "2"
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/EmbeddedApp/checkout-api.js
var checkout_api = __webpack_require__(97120);
// EXTERNAL MODULE: ./components/EmbeddedApp/PageTypes/IframePage/index.js
var IframePage = __webpack_require__(17665);
// EXTERNAL MODULE: ./webserver-page.tsx
var webserver_page = __webpack_require__(82673);
;// CONCATENATED MODULE: ./pages/embedded-checkout/cart-button.jsx



function cart_button_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  body {\n    background: none transparent;\n  }\n\n  ",
        "\n"
    ]);
    cart_button_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














function CartButtonIframe(param) {
    var secureSessionToken = param.secureSessionToken, showButton = param.showButton, checkoutId = param.checkoutId, instanceId = param.instanceId, initialStyle = param.style;
    var ref = (0,react.useState)(initialStyle), style = ref[0], setStyling = ref[1];
    var parentPage = CartParentPage({
        instanceId: instanceId
    });
    (0,react.useEffect)(function() {
        parentPage.loaded(showButton);
        var elem = document.body;
        var resizeObserver = new resize_observer/* ResizeObserver */["do"](function() {
            parentPage.sizeChanged(elem.offsetWidth, elem.offsetHeight);
        });
        resizeObserver.observe(elem);
    }, []);
    (0,event_listener_m/* default */.Z)("message", function(event) {
        var message = event.data;
        if ((message === null || message === void 0 ? void 0 : message.type) && (message === null || message === void 0 ? void 0 : message.data)) {
            var type = message.type, data = message.data;
            if (type === "UPDATE") {
                setStyling((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
                    fill: data.fill
                }));
            }
        }
    });
    (0,event_listener_m/* default */.Z)("storage", function() {
        var checkoutSession = session_storage/* getItem */.rV("checkoutSession");
        var show = checkoutSession && checkoutSession.lineItems.length > 0;
        parentPage.postVisibilityChanged({
            show: show
        });
    });
    useSecureTokenEffect({
        secureSessionToken: secureSessionToken
    });
    useFetchCheckoutEffect({
        checkoutId: checkoutId
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(IframePage/* default */.Z, {
        head: {},
        useFullstory: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NoBodyBackground, {
                globalCSS: "html,body { height: ".concat(style.height, "; width: ").concat(style.width, "; }")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button, {
                styling: style,
                onMouseEnter: function onMouseEnter() {
                    // Check if we have a mouse and dont fire if we dont
                    if (!window.matchMedia("(pointer:fine)").matches) {
                        return;
                    }
                    parentPage.cartButtonEntered();
                },
                onClick: function onClick() {
                    parentPage.cartButtonClicked();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClockIcon, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertIcon, {
                        "data-testid": "alert-icon",
                        styling: style
                    })
                ]
            })
        ]
    });
}
var NoBodyBackground = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(cart_button_templateObject(), function(param) {
    var globalCSS = param.globalCSS;
    return globalCSS || "";
});
function useSecureTokenEffect(param) {
    var secureSessionToken = param.secureSessionToken;
    if (secureSessionToken) {
        local_storage/* setItem */.LS("_pd_secure_session_token", secureSessionToken);
    }
}
/*
  Fetch and save the checkout session as soon as possible
  so the other components can use it
*/ function useFetchCheckoutEffect(param) {
    var checkoutId = param.checkoutId;
    var FetchCheckoutTask = (0,dist_web/* useAsync */.r5)({
        deferFn: checkout_api/* fetchCheckout */.PL,
        onResolve: function onResolve(data) {
            session_storage/* setItem */.LS("checkoutSession", data);
        },
        onReject: function onReject(err) {
            // biome-ignore lint/suspicious/noConsole: log
            console.error("PurpleDot: Failed to fetch checkout for ".concat(checkoutId), err);
        }
    });
    (0,react.useEffect)(function() {
        if (checkoutId) {
            session_storage/* setItem */.LS("serverCheckoutId", checkoutId);
            FetchCheckoutTask.run({
                checkoutId: checkoutId
            });
        } else {
            session_storage/* removeItem */.cl("checkoutSession");
            session_storage/* removeItem */.cl("serverCheckoutId");
        }
    }, []);
}
function CartParentPage(param) {
    var instanceId = param.instanceId;
    var sendMessage = function sendMessage(type, data) {
        window.parent.postMessage({
            meta: {
                placementType: "cart-button",
                instanceId: instanceId,
                type: type
            },
            data: data || {}
        }, "*");
    };
    if (!instanceId) {
        throw new Error("No instanceId provided");
    }
    return {
        loaded: function loaded(showButton) {
            sendMessage("loaded", {
                showButton: showButton
            });
        },
        sizeChanged: function sizeChanged(width, height) {
            sendMessage("window-size-changed", {
                width: width,
                height: height
            });
        },
        postVisibilityChanged: function postVisibilityChanged(param) {
            var show = param.show;
            sendMessage("visibility-changed", {
                show: show
            });
        },
        cartButtonEntered: function cartButtonEntered() {
            sendMessage("cart-button-entered");
        },
        cartButtonClicked: function cartButtonClicked() {
            sendMessage("cart-button-clicked");
        }
    };
}
/* harmony default export */ var cart_button = ((0,webserver_page/* default */.Z)(CartButtonIframe));


/***/ }),

/***/ 82673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11204);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80460);
/* harmony import */ var _purple_dot_libraries_src_fetch__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78960);
/* harmony import */ var _purple_dot_libraries_src_url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82052);
/* harmony import */ var _components_common_linking__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7307);





function expressPage(pageComponent) {
    if (componentHasProps(pageComponent)) {
        pageComponent.getInitialProps = getInitialProps;
    }
    return pageComponent;
}
function componentHasProps(pageComponent) {
    return pageComponent.length > 0;
}
function getInitialProps(_) {
    return _getInitialProps.apply(this, arguments);
}
function _getInitialProps() {
    _getInitialProps = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(param) {
        var req, query, asPath, url, data, __redirect, pathname, q, path;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    req = param.req, query = param.query, asPath = param.asPath;
                    if (!!isOnServer(req)) return [
                        3,
                        2
                    ];
                    url = (0,_purple_dot_libraries_src_url__WEBPACK_IMPORTED_MODULE_0__/* .appendResourceType */ .J2)("json", asPath);
                    return [
                        4,
                        (0,_purple_dot_libraries_src_fetch__WEBPACK_IMPORTED_MODULE_4__/* .fetchJSON */ .ZV)(url)
                    ];
                case 1:
                    data = _state.sent();
                    if (data._redirect) {
                        __redirect = data._redirect, pathname = __redirect.pathname, q = __redirect.query, path = __redirect.path;
                        void (0,_components_common_linking__WEBPACK_IMPORTED_MODULE_1__/* .routeTo */ .E)({
                            pathname: pathname,
                            query: q
                        }, path);
                        return [
                            2,
                            {}
                        ];
                    }
                    return [
                        2,
                        data
                    ];
                case 2:
                    return [
                        2,
                        query
                    ];
            }
        });
    });
    return _getInitialProps.apply(this, arguments);
}
function isOnServer(req) {
    return !!req;
}
/* harmony default export */ __webpack_exports__["Z"] = (expressPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2130,902,9515,5214,3753,7120,9774,2888,179], function() { return __webpack_exec__(27491); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);